import { Box, MenuItem, Switch, Typography } from "@mui/material";

export const ToggleBulkSelection = ({
    bulkSelectEnabled,
    setBulkSelectEnabled,
    closeMenu,
}) => {
    return (
        <>
            <MenuItem onClick={closeMenu}>
                <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                >
                    <Typography varient="body1">Bulk select</Typography>
                    <Switch
                        checked={bulkSelectEnabled}
                        onChange={(e) => setBulkSelectEnabled(e.target.checked)}
                        inputProps={{ "aria-label": "controlled" }}
                    />
                </Box>
            </MenuItem>
        </>
    );
};
